import * as Yup from 'yup';

const bundleSubcategorySchema = Yup.object().shape({
  bundleCategoryId: Yup.string().required('Bundle category is required.'),
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  imgUrl: Yup.string().nullable().notRequired(),
  position: Yup.number()
    .min(1, 'Please enter more than 0')
    .typeError('Must be Number'),
});

export default bundleSubcategorySchema;
